import * as React from 'react';
import { cx } from 'linaria';
import { VisuallyHidden } from '../';
import * as styles from './spinner.styles';

export interface SpinnerProps {
    /** Size of the spinner
     *  @default medium
     */
    size?: 'small' | 'medium' | 'large';
    /**
     *  Color of the spinner
     *  @default secondary
     */
    variant?: 'primary' | 'secondary' | 'muted';
    /**
     *  Test id for unit and e2e
     */
    testId?: string;
}

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>((props, ref) => {
    const { size = 'medium', variant = 'secondary', testId } = props;

    const svgSize = React.useMemo(() => {
        if (size === 'small') {
            return 24;
        }
        if (size === 'medium') {
            return 32;
        }

        return 44;
    }, [size]);

    return (
        <div ref={ref} role="status" data-testid={testId}>
            <VisuallyHidden>Loading</VisuallyHidden>
            <svg
                className={cx(styles.root, styles.variants[variant])}
                viewBox="0 0 42 42"
                width={svgSize}
                height={svgSize}
                xmlns="http://www.w3.org/2000/svg"
                role="presentation"
            >
                <path
                    d="M21 3a18 18 0 1018 18"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
});

Spinner.displayName = 'Spinner';
